import { render, staticRenderFns } from "./ImageLayerLegend.vue?vue&type=template&id=f722633e&name=image-layer-legend&"
import script from "./ImageLayerLegend.vue?vue&type=script&lang=js&"
export * from "./ImageLayerLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports